import { Box } from '@stenajs-webui/core';
import { Spinner } from '@stenajs-webui/elements';
import { Colors } from '../common/colors';

export const Loading = () => (
  <Box alignItems={'center'}>
    <Spinner color={Colors.Freight2} size={'medium'} />
  </Box>
);
